import { computed } from "vue";
import { createAcl, defineAclRules } from "vue-simple-acl";
import { useUserStore } from "@/stores/userStore";

const user = computed(() => {
  const store = useUserStore();
  return { tipoId: store.tipoId };
});

const rules = () =>
  defineAclRules((setRule) => {
    setRule("admin", (u) => u.tipoId === 1);
    setRule("supervisor", (u) => u.tipoId <= 2);
    setRule("investidor", (u) => u.tipoId === 3);
    setRule("vendedor", (u) => u.tipoId === 4);
    setRule("designer", (u) => u.tipoId === 5);
  });

const acl = createAcl({ user, rules });

export default acl;
